<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ContentTitle>{{title}}</ContentTitle>
        <ContentSubTitle>Based on current inventory values</ContentSubTitle>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <StaticDataTable class="static-table-list" :striped="true">
          <template v-slot:header>
            <tr>
              <th>Name</th>
              <th>{{dataTitle}}</th>
            </tr>
          </template>
          <template v-slot:body>
            <template v-for="(valueInfo, index) in valueList">
              <tr :key="`stock-info-${index}`">
                <td class="font-weight-bold">
                  <LinkStock v-if="valueInfo.stockId" :name="valueInfo.name" :id="valueInfo.stockId" />
                  <LinkContact v-else-if="valueInfo.contactId" :name="valueInfo.name" :id="valueInfo.contactId" />
                  <span v-else>{{valueInfo.name}}</span>
                </td>
                <td>
                  <span v-html="valueInfo.displayValue"></span>
                </td>
              </tr>
            </template>
          </template>
          <template v-slot:empty v-if="valueList.length == 0">
            No data found
          </template>
        </StaticDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

export default {
  name: 'InventoryValueSummaryList',
  components: {
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  props: {
    title: String,
    dataTitle: String,
    valueList: Array
  },
  data() {
    return {
      editingStartDate: this.startDate,
      editingEndDate: this.endDate,
    }
  },
  methods: {
    applySummaryFilter() {
      this.$emit('applyFilter', { startDate: this.editingStartDate, endDate: this.editingEndDate })
    },
    resetSummaryFilter() {
      this.$emit('resetFilter')
    },
  }
}
</script>